import {pageInfo,getDeviceAttribute,updateDeviceAttributeValue,operateOpStatus} from './../api';
import {Message} from 'element-ui';
import {plant} from "../../../../api";

const interfaceLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    attributeTotal: 0,
    attributePageResp: null,
    plantObj: [],
    plantAreaObj: [],
    exportObj: [],
    updateDeviceAttributeValueObj: null,
    operateOpStatusObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [item.deviceTypeCode == 'qc_machine']}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    GET_DEVICE_ATTRIBUTE(state, data) {
      state.attributeTotal = data.total;
      state.attributePageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    UPDATE_DEVICE_ATTRIBUTE_VALUE(state, data) {
      state.updateDeviceAttributeValueObj = data;
    },
    OPERATE_OP_STATUS(state, data) {
      state.operateOpStatusObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async getDeviceAttribute({commit}, obj) {
      let resp = await getDeviceAttribute(obj);
      commit('GET_DEVICE_ATTRIBUTE', resp);
    },
    async updateDeviceAttributeValue({commit}, obj) {
      let resp = await updateDeviceAttributeValue(obj);
      commit('UPDATE_DEVICE_ATTRIBUTE_VALUE', resp);
    },

    async operateOpStatus({commit}, obj) {
      let resp = await operateOpStatus(obj);
      commit('OPERATE_OP_STATUS', resp);
    },


  }
}
export default interfaceLog



// WEBPACK FOOTER //
// ./src/page/md/device/store/device.store.js